<template>
  <b-container fluid>
    <esg-base-card v-show="!loading"
                   title="자료제출 모니터링"
                   :footer="false">
      <loading :active="loading"
               :z-index="1000"/>
      <b-container fluid
                   class="my-3 px-0">
        <b-row align-h="start">
          <b-col md="6"
                 lg="2"
                 class="mt-3 mt-lg-0">
            <esg-single-score-card title="평가완료"
                                   :score="30"
                                   score-unit="사"/>
          </b-col>
          <b-col md="6"
                 lg="2">
            <esg-single-score-card title="평가대상"
                                   :score="249"
                                   score-unit="사"/>
          </b-col>
          <b-col md="6"
                 lg="2"
                 class="mt-3 mt-lg-0">
            <esg-single-score-card title="제출완료"
                                   :score="40"
                                   score-unit="사"/>
          </b-col>
          <b-col md="6"
                 lg="2"
                 class="mt-3 m-md-0">
            <esg-single-score-card title="미제출"
                                   :score="180"
                                   score-unit="사"/>
          </b-col>

          <b-col md="6"
                 lg="2"
                 class="mt-3 mt-lg-0">
            <esg-single-score-card title="반려"
                                   :score="29"
                                   score-unit="사"/>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <EsgPartnerCorpMonitoringProgressManagementGrid :gridId="0"/>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col lg="5">
            <ct00038 :data="'test'"/>
          </b-col>
          <b-col lg="7">
            <ct00039 style="padding:0;"/>
          </b-col>
        </b-row>
      </b-container>
    </esg-base-card>
  </b-container>
</template>
<script>
import Loading from 'vue-loading-overlay'

import EsgCardHeader from "@/components/esg/base/EsgBaseCardHeader.vue";
import EsgPartnerCorpMonitoringProgressManagementGrid from "./EsgPartnerCorpMonitoringProgressManagementGrid.vue"
import ct00038 from '../../charts/ct00038.vue'
import ct00039 from '../../charts/ct00039.vue'
import EsgSingleScoreCard from "@/components/esg/base/EsgSingleScoreCard.vue";
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import EsgBaseCard from "@/components/esg/base/EsgBaseCard.vue";

export default {
  name: 'EsgPartnerCorpMonitoring',
  components: {
    EsgBaseCard,
    Loading,
    EsgCardHeader,
    EsgPartnerCorpMonitoringProgressManagementGrid,
    ct00038,
    ct00039,
    EsgSingleScoreCard,
    EsgBaseDashboardCard
  },
  data() {
    return {
      loading: false
    }
  }
}
</script>
<style scoped>
#EsgPartnerCorpMonitoringProgressManagement h1 {
  color: black;
  font-weight: bold;
}
</style>
